module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/xxwNDY/tc-custom/9780830849345.jpg?1696363104805",
      "alt": "This image is the cover for the book Sermons That Sing, Dynamics of Christian Worship"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Sermons That Sing, Dynamics of Christian Worship\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('strong', [_vm._v("Preaching and music are both regular elements of Christian worship across the theological spectrum.")]), _vm._v(" But they often don't interact or inform each other in meaningful ways.")]), _vm._v(" "), _c('p', [_vm._v("In this Dynamics of Christian Worship volume, theologian, pastor, and musician Noel A. Snyder considers how the church's preaching might be helpfully informed by musical theory. Just as a good musical composition employs technical elements like synchrony, repetition, and meter, the same should be said for good preaching that seeks to engage hearts and minds with the good news of Jesus Christ.")]), _vm._v(" "), _c('p', [_vm._v("By drawing upon music that lifts the soul, preachers might craft sermons that sing.")]), _vm._v(" "), _c('p', [_vm._v("The Dynamics of Christian Worship series draws from a wide range of worshiping contexts and denominational backgrounds to unpack the many dynamics of Christian worship—including prayer, reading the Bible, preaching, baptism, the Lord’s Supper, music, visual art, architecture, and more—to deepen both the theology and practice of Christian worship for the life of the church.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Noel A. Snyder, Jeremy Begbie\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', [_vm._v("Noel A. Snyder (PhD, Fuller Theological Seminary) is program manager at the Calvin Institute of Christian Worship at Calvin University and an ordained teaching elder in the Presbyterian Church (USA).")]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    InterVarsity Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0